// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LVwFc","newExpiryDate":"styles_newExpiryDate__2sGTu","footer":"styles_footer__3Juyb"};